import React from 'react';

export default function useAudioPlayer() {
  const audioRef = React.useRef(null);
  const [state, setState] = React.useState(INITIAL_STATE);

  const sync = React.useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;
    setState((prev) => ({ ...prev, ...readAudioState(audio, prev) }));
  }, []);

  const toggle = React.useCallback(async () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) await audio.play().catch(() => {});
    else audio.pause();
    sync();
  }, [sync]);

  const seek = React.useCallback((next) => {
    if (audioRef.current) audioRef.current.currentTime = next;
    setState((prev) => ({ ...prev, current: next }));
  }, []);

  const changeVolume = React.useCallback((volume) => {
    if (audioRef.current) audioRef.current.volume = volume;
    setState((prev) => ({ ...prev, volume }));
  }, []);

  const reset = React.useCallback(() => {
    if (audioRef.current) audioRef.current.currentTime = 0;
    setState((prev) => ({ ...prev, current: 0, playing: false }));
  }, []);

  return { audioRef, state, sync, reset, toggle, seek, changeVolume };
}

const INITIAL_STATE = {
  playing: false,
  current: 0,
  duration: 0,
  volume: 0.8,
};

function readAudioState(audio, previous) {
  return {
    current: audio.currentTime || 0,
    duration: audio.duration || previous.duration,
    playing: !audio.paused,
  };
}
